import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

export async function ensureSignupGrant() {
  const ensureGrant = httpsCallable(functions, 'ensureSignupGrant');
  return ensureGrant();
}
